module.exports = __webpack_public_path__ + "static/img/247_TO8_2211_og.8bff27c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/247_TO8_2211_og.jpg
// module id = s5Rk
// module chunks = 0